/** Пункты навигации (docs/08-screens.md). Иконки только из Lucide. */
export interface NavItem {
  id: string;
  label: string;
  icon: string;
  path: string;
}

export const NAV_ITEMS: NavItem[] = [
  { id: 'overview', label: 'Обзор', icon: 'LayoutDashboard', path: '/' },
  { id: 'finance', label: 'Финансы', icon: 'Wallet', path: '/finance' },
  { id: 'wallets', label: 'Кошельки', icon: 'CreditCard', path: '/wallets' },
  { id: 'tasks', label: 'Задачи', icon: 'CheckSquare', path: '/tasks' },
  { id: 'notifications', label: 'Уведомления', icon: 'Bell', path: '/notifications' },
  { id: 'settings', label: 'Настройки', icon: 'Settings', path: '/settings' },
];

export const PAGE_TITLES: Record<string, string> = {
  '/': 'Обзор',
  '/finance': 'Финансы',
  '/wallets': 'Кошельки',
  '/tasks': 'Задачи',
  '/notifications': 'Уведомления',
  '/settings': 'Настройки',
};
